import { render, staticRenderFns } from "./CredentialTable.vue?vue&type=template&id=0c1d700b"
import script from "./CredentialTable.vue?vue&type=script&lang=js"
export * from "./CredentialTable.vue?vue&type=script&lang=js"
import style0 from "./CredentialTable.vue?vue&type=style&index=0&id=0c1d700b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports